import { gql } from '@apollo/client'

export const CREATE_M2_CASE_MUTATION = gql`
  mutation createM2Case($attributes: M2CaseInput!) {
    createM2Case(attributes: $attributes) {
      id
      policyholder {
        id
        duplicateEmail
        possibleDuplicate
      }
    }
  }
`
